<template>
	<div class="goods-detail-container" v-loading="loading">
		<el-card class="box-card-detail card-flex" shadow="never" v-if="goodsObj">
			<div class="album-box">
				<div class="img-box">
					<img :src="picUrl" alt="" v-if="picUrl">
					<img v-else src="../../assets/images/product-hold.png" class="product-hold" />
				</div>
				<div class="swiper-box" v-if="getImg.length > 0">
					<swiper ref="mySwiper" :options="swiperOptions">
						<swiper-slide v-for="(item,index) in getImg" :key="index">
							<div class="img-box" @mousemove="mousemove(item)">
								<img :src="item" alt="">
							</div>
						</swiper-slide>
						<!-- <div class="swiper-pagination" slot="pagination"></div> -->
					</swiper>
					<div class="swiper-button-prev" slot="button-prev">
						<i class="el-icon-arrow-left icon"></i>
					</div>
					<div class="swiper-button-next" slot="button-next">
						<i class="el-icon-arrow-right icon"></i>
					</div>
				</div>
			</div>
			<div class="infor-box">
				<div class="infor-title">{{goodsObj.name}}</div>
				<div class="price-box">
					<div class="price-line">
						<template v-if="hasLogin">
							<div class="buy-price">
								<span class="buy-price-text">价<span
										:style="{'marginRight': goodsObj.activities.length > 0 && goodsObj.activities.filter(e=>e.type == 2).length > 0 ? '14px' : '0'}"></span>格：</span>￥
								<span
									v-if="goodsObj.activities && goodsObj.activities.filter(data => [4, 5, 6].indexOf(data.type) !== -1).length > 0">
									<template v-if="goodsObj.activities.filter(e => e.type == 4).length > 0">
										{{ parseFloat(goodsObj.activities.filter(e => e.type == 4)[0].buyPrice) }}
									</template>
									<template v-if="goodsObj.activities.filter(e => e.type == 5).length > 0">
										{{ parseFloat((goodsObj.activities.filter(e => e.type == 5)[0].discount * goodsObj.buyPrice).toFixed(2))}}
									</template>
									<template v-if="goodsObj.activities.filter(e => e.type == 6).length > 0">
										{{ parseFloat(goodsObj.activities.filter(e => e.type == 6)[0].buyPrice) }}
									</template>
								</span>
								<span v-else>{{goodsObj.buyPrice}}</span>
								<span class="underlined-price"
									v-if="goodsObj.activities && goodsObj.activities.filter(data => [4, 5, 6].indexOf(data.type) !== -1).length > 0">￥{{goodsObj.buyPrice}}</span>
								<span class="retail-price"
									v-if="goodsObj.retailPrice">建议零售价￥{{goodsObj.retailPrice}}</span>
							</div>
							<div class="active-count-down" v-if="getActivity6CountDown">
								<div class="title">
									距结束还剩
								</div>
								<count-down
									:endTime="(new Date(activityList6[0].enableEndTime.replace(/-/g, '/')).getTime() / 1000).toString()"
									@callback="handleEndYushou" />
							</div>
						</template>
						<div class="tip" v-else><span class="buy-price-text">价格：</span>价格登录后可见</div>
					</div>
					<div class="activity-single-gift"
						v-if="goodsObj.activities.length > 0 && goodsObj.activities.filter(e=>e.type == 2).length > 0">
						赠<span :style="{'marginRight': '14px'}"></span>品：
						<div class="gift-img-box">
							<img :src="goodsObj.activities.filter(e=>e.type == 2)[0].giftProductDtos[0].pic" alt="">
						</div>
						<span>{{goodsObj.activities.filter(e=>e.type == 2)[0].giftProductDtos[0].name}}</span><span>*{{goodsObj.activities.filter(e=>e.type == 2)[0].giftProductDtos[0].count}}</span>
					</div>

					<div class="tag-box">
						<div class="tag-content" :style="{'width': productCouponList.length > 0 ? '90%' : '100%'}">
							<!-- 除赠品之外 活动 type =（0：全场券；1：单品券；2：买赠；3：满减；4：特价；5：折扣；6：秒杀；7：限购）-->
							<div class="activity-box"
								v-if="goodsObj.activities.filter(data => [3, 4, 5, 6, 7].indexOf(data.type) !== -1).length > 0">
								<div class="activity-line"
									v-for="(activityItem, index) in goodsObj.activities.filter(data => [3, 4, 5, 6, 7].indexOf(data.type) !== -1)"
									:key="index">
									<span class="activity-single activity-single-cursor" v-if="activityItem.type == 3"
										@click="goGroupOrder(activityItem)">满{{parseFloat(activityItem.minPoint)}}减{{parseFloat(activityItem.amount)}}
										<span class="go-gather">去凑单<i class="iconfont icon-gengduo1"></i></span>
									</span>
									<span class="activity-single" v-if="activityItem.type == 4">特价</span>
									<span class="activity-single"
										v-if="activityItem.type == 5">限时{{ parseFloat(10 * activityItem.discount) }}折</span>
									<span class="activity-single" v-if="activityItem.type == 6">限时抢购
									</span>
									<span class="activity-single" v-if="activityItem.type == 7">限购
										<span v-if="activityItem.perLimit && activityItem.perLimit < 999">
											{{ activityItem.perLimit }}件
										</span>
									</span>
								</div>
							</div>
							<!-- 单品优惠劵 -->
							<div class="activity-box" v-if="productCouponList.length > 0">
								<!-- 有赠品活动时显示优惠劵文字 -->
								<div class="coupon-text"
									v-if="goodsObj.activities.length > 0 && goodsObj.activities.filter(e=>e.type == 2).length > 0">
									优惠劵：
								</div>
								<div class="activity-line">
									<span class="activity-single"
										v-for="(couponItem, couponIndex) in productCouponList.slice(0,3)"
										:key="couponIndex">
										{{parseFloat(couponItem.amount)}}元优惠劵
									</span>
								</div>
							</div>
						</div>
						<div class="go-receive" v-if="productCouponList.length > 0" @click="goReceive()">
							去领取<i class="iconfont icon-gengduo1"></i>
						</div>
					</div>
					<!-- 					<div class="sales">
						<div>销量</div>
						<div>9999+</div>
					</div> -->
				</div>
				<div class="msg" v-if="goodsObj.speci">
					<span class="label">规</span>
					{{goodsObj.speci}}
				</div>
				<div class="msg" v-if="goodsObj.manufacturers">
					<span class="label">厂</span>
					{{goodsObj.manufacturers}}
				</div>
				<div class="msg" v-if="goodsObj.validity">
					<span class="label">效</span>
					效期：{{goodsObj.validity}}
				</div>
				<div class="number-box spec-box">
					<span class="label">规格：</span>
					<div class="btn-list">
						<el-button plain @click="handleSpec(goodsObj.packing,0)" :class="{select:selectIndex == 0}">
							中包装/{{goodsObj.packing}}
						</el-button>
						<el-button plain @click="handleSpec(goodsObj.pieces,1)" :class="{select:selectIndex == 1}">
							件装/{{goodsObj.pieces}}
						</el-button>
					</div>
				</div>
				<div class="number-box">
					<span class="label">数量：</span>
					<div class="cart-numbox">
						<div class="opt-icon" @click="numChange('subtract');"><i class="iconfont icon-jian"></i></div>
						<el-input v-model="num" type="number" @input="inputChange()" @blur="inputBlur()"
							@focus="inputFocus()"></el-input>
						<div class="opt-icon" @click="numChange('add');"><i class="iconfont icon-jia2"></i></div>
					</div>
					<span class="tip">{{goodsObj.minimumQuantity}}盒起购
						<template v-if="goodsObj.stock && activityList6.length == 0">，库存：{{ goodsObj.stock }}</template>
						<template
							v-if="activityList6.length > 0">，活动剩余库存：{{ parseInt(activityList6[0].count - activityList6[0].receiveCount) }}</template></span>
				</div>
				<template v-if="activityList6.length == 0">
					<el-button type="primary" v-if="!hasLogin || (userInfo && userInfo.enterpriseType != 'SALESMAN')"
						class="add-btn" :loading="addLoading" @click="handleAdd">加入购物车</el-button>
				</template>
				<template v-if="activityList6.length > 0">
					<el-button type="primary" class="add-btn" @click="goOrder();">立即下单</el-button>
				</template>
			</div>
		</el-card>

		<el-card class="box-card-detail" shadow="never" v-if="goodsObj">
			<div class="card-title">基础信息</div>
			<ul class="infor-list">
				<li>
					<div class="label">商品名称：</div>
					<div class="content">{{goodsObj.name}}</div>
				</li>
				<li>
					<div class="label">商品规格：</div>
					<div class="content">
						{{goodsObj.speci}}
					</div>
				</li>
				<li>
					<div class="label">生产厂家：</div>
					<div class="content">{{goodsObj.manufacturers}}</div>
				</li>
				<li v-if="goodsObj.zzlbDes">
					<div class="label">类别名称：</div>
					<div class="content">{{goodsObj.zzlbDes}}</div>
				</li>
				<li v-if="goodsObj.zzjyfwDes">
					<div class="label">GSP编码名称：</div>
					<div class="content">{{goodsObj.zzjyfwDes}}</div>
				</li>
				<!-- <li>
					<div class="label">批准文号：</div>
					<div class="content">{{goodsObj.name}}</div>
				</li>
				
				<li>
					<div class="label">条形码：</div>
					<div class="content">
						{{goodsObj.name}}
					</div>
				</li>
				<li>
					<div class="label">功能主治：</div>
					<div class="content">
						{{goodsObj.name}}
					</div>
				</li>
				<li>
					<div class="label">主要成分：</div>
					<div class="content">
						{{goodsObj.name}}
					</div>
				</li>
				<li>
					<div class="label">用法用量：</div>
					<div class="content">
						{{goodsObj.name}}
					</div>
				</li>
				<li>
					<div class="label">不良反应：</div>
					<div class="content">
						{{goodsObj.name}}
					</div>
				</li>
				<li>
					<div class="label">注意事项：</div>
					<div class="content">
						{{goodsObj.name}}
					</div>
				</li>
				<li>
					<div class="label">禁忌说明：</div>
					<div class="content">
						{{goodsObj.name}}
					</div>
				</li>
				<li>
					<div class="label">性状：</div>
					<div class="content">
						{{goodsObj.name}}
					</div>
				</li>
				<li>
					<div class="label">相互作用：</div>
					<div class="content">
						{{goodsObj.name}}
					</div>
				</li>
				<li>
					<div class="label">贮藏：</div>
					<div class="content">
						{{goodsObj.name}}
					</div>
				</li> -->
			</ul>
		</el-card>
		<el-empty v-else description="暂无数据"></el-empty>
	</div>
</template>

<script>
	import Cookies from "js-cookie";
	import countDown from '@/components/countDown.vue'
	import {
		getProductCoupon
	} from "@/api/home.js";
	import {
		swiper,
		swiperSlide
	} from 'vue-awesome-swiper'
	import {
		getProInfo,
		updateCartData,
		serverTimeApi
	} from "@/api/goods"
	import {
		mapGetters,
		mapMutations
	}
	from 'vuex';
	export default {
		components: {
			swiper,
			swiperSlide,
			countDown
		},
		data() {
			return {
				loading: false,
				addLoading: false,
				picUrl: '',
				goodsObj: "",
				num: 1,
				specList: [{
						name: '1包/10盒',
						num: 10
					},
					{
						name: '1包/50盒',
						num: 50
					},
					{
						name: '1包/100盒',
						num: 100
					}
				],
				selectIndex: 0,
				swiperOptions: {
					slidesPerView: 4,
					spaceBetween: 13,
					pagination: {
						el: '.swiper-pagination', //与slot="pagination"处 class 一致
						clickable: true, //轮播按钮支持点击
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					slidesPerGroup: 4,
				},
				activityList6: [],
				serverTime: null, // 服务器时间
				productCouponList: [],
				productCouponListp: [],
				historyQuantity: null
			}
		},
		beforeMount() {
			this.loading = true
			this.getProInfo(this.$route.query.id)
		},
		watch: {
			'$store.state.userInfo.groupId'(val) {
				this.loading = true
				this.getProInfo(this.$route.query.id)
			},
		},
		computed: {
			...mapGetters(['vuex_cartList', 'hasLogin', 'userInfo']),
			getImg() {
				let arr = []
				if (this.goodsObj.albumPics) this.goodsObj.albumPics.split(',')
				if (this.goodsObj.pic) arr.unshift(this.goodsObj.pic)
				return arr;
			},
			// 倒计时显示状态
			getActivity6CountDown() {
				if (this.goodsObj.activities && this.goodsObj.activities.length > 0) {
					if (this.goodsObj.activities.filter(item => item.type == 6).length > 0) {
						if ((new Date(this.activityList6[0].enableEndTime.replace(/-/g, '/')).getTime() - this
							.serverTime) / 1000 >
							0 &&
							(new Date(this.activityList6[0].enableStartTime.replace(/-/g, '/')).getTime() - this
								.serverTime) / 1000 < 0
						) {
							return true;
						}
					}
					return false;
				}
				return false;
			},
			perLimit() {
				if (this.goodsObj && this.goodsObj.activities && this.goodsObj.activities.filter(e => e.type == 7).length >
					0) {
					return this.goodsObj.activities.filter(e => e.type == 7)[0].perLimit;
				} else {
					return 0;
				}
			},
		},
		methods: {
			inputChange() {
				if (this.num != '' && this.num < 1) {
					this.num = 1;
				}
			},
			inputFocus() {
				this.historyQuantity = this.num;
			},
			inputBlur() {
				if (!this.num || this.num == '') {
					if (this.historyQuantity) {
						this.num = this.historyQuantity;
					} else {
						if (this.selectIndex == 0) {
							this.num = parseInt(this.goodsObj.packing)
						} else {
							this.num = parseInt(this.goodsObj.pieces)
						}
					}
					return false;
				}
				if (this.selectIndex == 0) {
					this.num = parseInt(Math.ceil(this.num / this.goodsObj.packing) * this.goodsObj.packing)
				} else {
					this.num = parseInt(Math.ceil(this.num / this.goodsObj.pieces) * this.goodsObj.pieces)
				}

				// 判断最小采购数量
				if (this.num < this.goodsObj.minimumQuantity) {
					this.$message.warning('该商品最少' + this.goodsObj.minimumQuantity + '件起购！');
				}

				// 判断库存数量
				if (this.num > this.goodsObj.stock) {
					this.$message.warning('库存不足！');
				}

				if (this.num < this.goodsObj.minimumQuantity || this.num > this.goodsObj.stock) {
					if (this.historyQuantity) {
						this.num = this.historyQuantity;
					}
					return false;
				}
			},
			numChange(type) {
				let packing = null;
				if (this.selectIndex == 0) {
					packing = parseInt(this.goodsObj.packing);
				} else {
					packing = parseInt(this.goodsObj.pieces);
				}
				// 单次加购数
				let buyNum = packing;
				if (type == 'subtract') {
					if (this.num <= 1) {
						return false;
					}
					// 判断最小采购数量
					if ((this.num - buyNum) < this.goodsObj.minimumQuantity) {
						this.$message.warning('该商品最少' + this.goodsObj.minimumQuantity + '件起购！');
						return false;
					} else {
						// 计算数量
						this.num = this.num - buyNum;
					}
				} else if (type == 'add') {
					if ((this.num + buyNum) > this.goodsObj.stock) {
						this.$message.warning('库存不足！');
						return false;
					} else {
						// 活动 6 秒杀（限时抢购）
						if (this.activityList6.length > 0 && this.num + buyNum > parseInt(this.activityList6[0].count -
								this.activityList6[0].receiveCount)) {
							this.$message.warning('已达活动商品数量上限');
							return false;
						}
						// 活动 7 限购数量拦截
						else if (this.perLimit > 0 && this.num + buyNum > this.perLimit) {
							this.$message.warning('限购' + this.perLimit + (this.goodsObj.mseh3 ? this.goodsObj.mseh3 :
							'件'));
							return false;
						} else {
							this.num = this.num + buyNum;
						}
					}
				}

			},

			handleSpec(num, index) {
				this.selectIndex = index;
				this.num = parseInt(num);
			},
			getProInfo(productTypeCode) {
				getProInfo({
					productTypeCode
				}).then(res => {
					this.loading = false
					if (res && res.code == 0 && res.data && res.data.length > 0) {
						this.goodsObj = res.data[0]
						this.num = parseInt(res.data[0].packing)
						if (this.goodsObj.pic) this.picUrl = this.goodsObj.pic
						// 赋值促销活动列表6秒杀
						if (this.goodsObj.activities.length > 0) {
							this.activityList6 = this.goodsObj.activities.filter(e => e.type == 6);
							if (this.activityList6.length > 0) {
								this.onServerTime();
							}
						}
					} else {
						this.goodsObj = ''
					}
				})

				if (this.hasLogin) {
					getProductCoupon({ // 获取优惠券信息
						productCode: productTypeCode
					}).then(res => {
						if (res && res.code == 0) {
							if (res.data) {
								this.productCouponList = res.data;
							}
						}
					})
				}
			},
			// 获取服务器时间
			onServerTime() {
				serverTimeApi().then((res) => {
					if (res?.code == 0 && res?.data) {
						this.serverTime = new Date(res.data).getTime();
					}
				});
			},
			mousemove(e) {
				this.picUrl = e
			},
			handleAdd() {
				if (this.hasLogin) {
					if (this.goodsObj.stock > 0) {
						if (this.num <= this.goodsObj.stock) {
							if (this.num < this.goodsObj.minimumQuantity) {
								this.$message({
									message: '最少采购' + this.goodsObj.minimumQuantity + '件！',
									type: 'warning'
								});
								return
							}
							let cartListFilter = this.vuex_cartList.filter(e => e.productTypeCode == this.goodsObj
								.productTypeCode);
							if (cartListFilter.length > 0) {
								if (this.perLimit > 0 && cartListFilter[0].quantity >= this.perLimit) {
									this.$message.warning('限购' + this.perLimit + (this.goodsObj.mseh3 ? this.goodsObj
											.mseh3 : '件') +
										',已加购' + cartListFilter[0].quantity + (this.goodsObj.mseh3 ? this.goodsObj
											.mseh3 : '件'));
									return false;
								}
							} else {
								if (this.perLimit > 0 && this.num > this.perLimit) {
									this.$message.warning('限购' + this.perLimit + (this.goodsObj.mseh3 ? this.goodsObj
										.mseh3 :
										'件'));
									return false;
								}
							}

							this.addLoading = true
							// 新增
							let params = {
								productType: this.goodsObj.productTypeCode,
								quantity: this.num,
							};
							let cartList = this.vuex_cartList
							let cartListLength = cartList.filter(e => e.productTypeCode == this.goodsObj.productTypeCode)
							if (cartListLength.length > 0) {
								// 增加数量
								params.plus = true
							}
							updateCartData(params).then(result => {
								this.addLoading = false
								if (result && result.code == 0) {
									this.$message({
										message: '加入购物车成功！',
										type: 'success'
									});
								} else {
									this.$message({
										message: result.msg ? result.msg : '加购失败！',
										type: 'warning'
									});
								}

							});
						} else {
							this.$message({
								message: '库存不足',
								type: 'warning'
							});
						}
					} else {
						this.$message({
							message: '库存不足',
							type: 'warning'
						});
					}
				} else {
					this.$router.push('/login?redirect=' + this.$route.fullPath);
				}
			},
			// 跳转去凑单页面
			goGroupOrder(data) {
				Cookies.remove("goodsListData");
				this.$router.push(
					`/goodsList?pageFrom=groupOrder&groupOrderId=${data.id}&amount=${data.amount}&minPoint=${data.minPoint}`
					);
			},
			// 跳转下单
			goOrder() {
				if (this.num < this.goodsObj.minimumQuantity) {
					this.$message({
						message: '最少采购' + this.goodsObj.minimumQuantity + '件！',
						type: 'warning'
					});
					return
				}
				if (this.activityList6.length > 0) {
					if (this.num > parseInt(this.activityList6[0].count - this.activityList6[0].receiveCount)) {
						this.$message({
							message: '已达活动商品数量上限',
							type: 'warning'
						});
						return
					}
				}
				var goodsObj = JSON.parse(JSON.stringify(this.goodsObj));
				goodsObj.quantity = this.num;
				goodsObj.xsqgActivityId = this.goodsObj.activities.filter(e => e.type == 6)[0].id
				window.sessionStorage.setItem('orderMsgSession', JSON.stringify(goodsObj));
				this.$router.push('/submitOrder');
			},
			// 预售活动结束 清除活动列表
			handleEndYushou() {
				this.activityList6 = [];
				if (this.goodsObj.activities.filter(item => item.type == 6).length > 0) {
					this.goodsObj.activities = [];
				}
			},
			goReceive() {
				this.$router.push('/coupon');
			}
		}
	}
</script>

<style lang="scss">
	.goods-detail-container {
		.cart-numbox {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			height: 34px;
			width: 130px;
			border: 1px solid #DCDFE6;
			border-radius: 4px;
			overflow: hidden;

			.opt-icon {
				flex-shrink: 0;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 34px;
				height: 100%;
				background: #F5F7FA;
				color: #606266;
				cursor: pointer;

				.iconfont {
					font-size: 12px;
					color: #C0C4CC;
				}
			}

			.el-input {
				.el-input__inner {
					padding: 0 8px;
					height: 34px;
					border-top: none;
					border-bottom: none;
					border-left: 1px solid #DCDFE6;
					border-right: 1px solid #DCDFE6;
					border-radius: 0;
					text-align: center;
					font-size: 14px;
				}
			}
		}

		.box-card-detail {
			padding: 30px;
			border: none;
			border: 1px solid #FFFFFF;
			border-radius: 8px;
			margin-bottom: 50px;
			width: 100%;

			.album-box {
				width: 352px;

				.img-box {
					width: 352px;
					height: 352px;
					border-radius: 10px;
					overflow: hidden;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
						border-radius: 10px;
					}

					.product-hold {
						background-color: #fff;
					}
				}

				.swiper-box {
					margin-top: 16px;
					width: 100%;
					position: relative;

					.swiper-container {
						width: calc(100% - 84px);
						margin: 0 auto;

						.swiper-slide {
							width: 58px;
							height: 58px;
							display: flex;
							justify-content: center;
							border-radius: 5px;
							font-size: 30px;
							font-weight: bold;

							.img-box {
								width: 58px;
								height: 58px;
								border-radius: 5px;

								img {
									width: 100%;
									height: 100%;
									object-fit: cover;
								}
							}
						}

						.swiper-pagination {
							.swiper-pagination-bullet-active {
								background-color: #F29B76;
							}
						}
					}

					.swiper-button-prev,
					.swiper-button-next {
						border: 1px solid #EDEFF2;
						border-radius: 50%;
						width: 26px;
						height: 26px;
						margin-top: -13px;
						background: none;
						font-size: 15px;

						.icon {
							font-weight: bold;
							width: 26px;
							height: 26px;
							line-height: 26px;
							text-align: center;
							color: #C0C4CC;
						}
					}

					.swiper-button-prev {
						left: 0;
					}

					.swiper-button-next {
						right: 0;
					}
				}

			}

			.card-title {
				font-size: 26px;
				font-weight: bold;
				color: #262728;
				margin-bottom: 40px;
			}

			.infor-list {
				color: #262728;
				font-size: 14px;

				li {
					margin-bottom: 25px;
					display: flex;

					.label {
						width: 100px;
						margin-right: 63px;
					}

					.content {
						flex: 1;
					}
				}

				li:last-child {
					margin-bottom: 0;
				}
			}
		}

		.card-flex {
			.el-card__body {
				display: flex;

				.infor-box {
					margin-left: 20px;
					width: calc(100% - 380px);

					.infor-title {
						font-size: 22px;
						color: #262728;
						margin-bottom: 10px;
					}

					.price-box {
						display: flex;
						justify-content: space-between;
						align-items: flex-start;
						flex-direction: column;
						background-color: #F3F3F3;
						box-sizing: border-box;
						padding: 9px 30px;
						margin-bottom: 18px;

						.price-line {
							color: #909399;
							font-size: 14px;
							display: flex;
							align-items: baseline;
							justify-content: space-between;
							width: 100%;

							.buy-price {
								.buy-price-text {
									color: #909399;
									font-size: 14px;
									font-weight: 400;
								}
							}

							div {
								color: #EE3C20;
								font-size: 14px;
								font-weight: bold;

								span {
									font-size: 24px;
								}
							}

							.underlined-price {
								margin-left: 8px;
								line-height: 1;
								font-size: 16px;
								font-weight: 400;
								color: #909399;
								text-decoration: line-through;
							}

							.retail-price {
								margin-left: 20px;
								line-height: 1;
								font-size: 16px;
								font-weight: 400;
								color: #909399;
							}
						}

						.sales {
							text-align: center;
							padding-left: 30px;
							position: relative;

						}

						.sales::before {
							position: absolute;
							top: 10px;
							bottom: 10px;
							width: 1px;
							content: "";
							background-color: #C0C4CC;
							left: -30px;
						}

						.tip {
							font-size: 15px;
							color: #ee3c20;
							margin-left: 5px;

							.buy-price-text {
								color: #909399;
								font-size: 14px;
								font-weight: 400;
							}
						}

						.activity-single-gift {
							color: #909399;
							font-size: 14px;
							display: flex;
							align-items: center;
							margin-bottom: 8px;

							.gift-img-box {
								width: 28px;
								height: 28px;
								background: #FFFFFF;
								border: 1px solid #FFFFFF;
								border-radius: 5px;
								margin-right: 5px;

								img {
									width: 100%;
									height: 100%;
									object-fit: cvoer;
									border-radius: 5px;
								}
							}

							span {
								font-size: 16px;
								font-weight: 400;
								color: #262728;
							}

							span:last-child {
								margin-left: 40px;
							}
						}

						.tag-box {
							width: 100%;
							display: flex;
							align-items: center;
							justify-content: space-between;

							.tag-content {
								display: inline-flex;
								box-sizing: border-box;
							}

							.go-receive {
								font-size: 14px;
								color: #FF6642;
								margin-left: 8px;
								display: flex;
								align-items: center;
								cursor: pointer;

								.icon-gengduo1 {
									margin-left: 4px;
									font-size: 10px;
								}
							}
						}

						.activity-box:last-child {
							margin-right: 0px;
						}

						.activity-box {
							margin-right: 8px;
							flex-shrink: 0;
							display: flex;

							.coupon-text {
								color: #909399;
								font-size: 14px;
							}

							.activity-line {
								display: flex;
								flex-wrap: wrap;
								flex: 1;

								.activity-single:last-child {
									margin-right: 0 !important;
								}

								.activity-single-cursor {
									cursor: pointer;
								}

								.activity-single {
									margin-right: 8px;
									display: flex;
									justify-content: center;
									align-items: center;
									height: 22px;
									padding: 0px 4px;
									background: #FFF6ED;
									border-radius: 4px;
									border: 1px solid #FF6642;
									font-size: 14px;
									color: #FF6642;

									.go-gather {
										margin-left: 8px;
										display: flex;
										align-items: center;

										.icon-gengduo1 {
											margin-left: 4px;
											font-size: 10px;
										}
									}
								}
							}
						}

						.active-count-down {
							display: flex;
							align-items: center;
							font-size: 16px;

							.title {
								color: #262728;
								font-size: 14px;
								font-weight: 400;
							}

							.count-down {
								font-weight: 400;

								span {
									font-size: 12px;
									display: inline-block;
									padding: 0 4px;
									width: auto;
									height: 22px;
									line-height: 22px;
									color: #fff;
									margin-left: 8px;
									margin-right: 8px;
									text-align: center;
									border-radius: 6px;
									background: #ff3b3a;
								}

								div {
									height: 18px;
									line-height: 17px;
									color: #c0c4cc;
									font-size: 14px;
									padding: 0;
								}
							}
						}
					}

					.msg {
						// display: flex;
						// justify-content: flex-start;
						// align-items: center;
						margin-bottom: 12px;
						padding-left: 10px;
						display: -webkit-box;
						-webkit-line-clamp: 1;
						-webkit-box-orient: vertical;
						overflow: hidden;
						text-overflow: ellipsis;
						width: 100%;
						box-sizing: border-box;
						line-height: 1;
						font-size: 16px;
						font-weight: 400;
						color: #909399;

						.label {
							flex-shrink: 0;
							display: inline-flex;
							justify-content: center;
							align-items: center;
							width: 22px;
							height: 22px;
							line-height: 20px;
							background: #FFFFFF;
							border: 1px solid #C0C4CC;
							border-radius: 5px;
							font-size: 14px;
							margin-right: 4px;
						}
					}

					.number-box {
						display: flex;
						align-items: center;
						margin-left: 10px;

						.label {
							font-size: 14px;
							color: #262728;
							margin-right: 8px;
						}

						.el-input-number {
							width: 130px;

							.el-input__inner:focus {
								border-color: #DCDFE6;
							}

							.el-input-number__increase:hover,
							.el-input-number__decrease:hover {
								color: #606266;
							}

							.el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled),
							.el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
								border-color: #DCDFE6;
							}
						}

						.tip {
							margin-left: 10px;
							color: #909399;
						}
					}

					.spec-box {
						margin-top: 32px;
						margin-bottom: 16px;

						.btn-list {
							.select {
								border-color: #FFCC00;
								color: #262728;
							}
						}
					}

					.add-btn {
						background-color: #FFCC00;
						color: #262728;
						font-weight: bold;
						margin-top: 40px;
						font-size: 20px;
					}

				}
			}
		}
	}
</style>